/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VerifyUserCreateParams { 
    /**
     * The channel of communication of the verification code.
     */
    channel: VerifyUserCreateParams.ChannelEnum;
    /**
     * The email, phone number, or user id of the user.
     */
    user_contact: string;
}
export namespace VerifyUserCreateParams {
    export type ChannelEnum = 'email' | 'sms' | 'service_code';
    export const ChannelEnum = {
        EMAIL: 'email' as ChannelEnum,
        SMS: 'sms' as ChannelEnum,
        SERVICE_CODE: 'service_code' as ChannelEnum
    };
}


